import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledPage = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5rem;
`;

export const StyledButton = styled(Button)`
  align-self: flex-start;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledTitle = styled.h1`
  margin: 0;
  color: ${pickThemeColor('DARK_PURPLE')};
  ${pickThemeFontStyles('40', '48', 'BOLD')};

  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
`;
